import React, {useState} from 'react'
import Button from 'lib/ui/Button'
import Dialog from 'lib/ui/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import TestAttendeeSearchField from 'organization/Event/Form/TestTagButton/TestAttendeeSearchField'
import styled from 'styled-components'
import {Attendee} from 'Event/attendee'
import {Service} from 'organization/Event/Services/ServicesProvider'
import SuccessAlert from 'lib/ui/alerts/SuccessAlert'

export default function SelectTestAttendeeDialog(props: {
  visible: boolean
  onClose: () => void
  onSelect: (attendee: Attendee | null) => Promise<void>
  integration: Service
}) {
  const {visible, onSelect, onClose, integration} = props
  const [showSuccess, setShowSuccess] = useState<boolean>(false)
  const [value, setValue] = useState<Attendee | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const select = () => {
    setLoading(true)
    setShowSuccess(false)
    onSelect(value)
      .then(() => {
        setShowSuccess(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Dialog
      open={visible}
      onClose={onClose}
      PaperProps={{
        style: {
          width: '100%',
          overflow: 'initial',
        },
      }}
    >
      <DialogTitle>Select attendee to test</DialogTitle>
      <StyledDialogContent>
        <Info>
          Only attendees imported with {integration} will be visible. <br /> If
          you can't find the attendee, please import it.
        </Info>
        <Content>
          <TestAttendeeSearchField
            onChange={setValue}
            value={value}
            integration={integration}
            disabled={loading}
          />
          <StyledButton
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={select}
          >
            Send Test
          </StyledButton>
        </Content>
        <SuccessAlert
          showing={showSuccess}
          onClose={() => {
            setShowSuccess(false)
          }}
        >
          Test tag is send
        </SuccessAlert>
      </StyledDialogContent>
    </Dialog>
  )
}

const Info = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[4]};
  font-size: 14px;
  font-style: italic;
`

const Content = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing[4]};

  & > div {
    flex: 6;
  }

  & > button {
    flex: 1;
  }
`

const StyledButton = styled(Button)`
  height: 32px;
  align-self: center;
`

const StyledDialogContent = styled(DialogContent)`
  overflow: initial;
  overflow: initial;
`
